import React from 'react'
import './ServiceCard.css'
import { motion } from 'framer-motion';

export default function ServiceCard(props) {
    return (

        <motion.div
            initial={props.initial}
            whileInView={props.whileInView}
            transition={props.transition}
            className={`service-card ${props.isActive ? 'active' : ''}`} 
            onMouseEnter={props.onMouseEnter}
            onMouseLeave={props.onMouseLeave}
        >
            <div className='icon'>
                {props.icon}
            </div>
            <div className='main container-vertical res-gap-8'>
                <h5 className='title text-align-left'>
                    {props.title}
                </h5>
                <div className='content'>
                    {props.children}
                </div>
            </div>
        </motion.div >

    )
}
